import { Link } from 'react-router-dom';
import homeBtn from './../imgs/home.png'

const HomeBtn = () => {
    return <Link className='login-decline-btn' to='/'>
      <img src={homeBtn} alt="backToHome"/>
      Home
    </Link>
}
export default HomeBtn;